import Swiper, { Pagination, Autoplay } from 'swiper'
import { Scrollbar, Popup } from '../core'
import './checkout'
import '../plugins/checkout-accordion'

$.fn.CartPanel = function() {
  let self = this
  self.fragmentsRequest = undefined
  self.requestResponse = undefined
  self.fancyboxOpened = false
  self.cta_carousel = undefined
  self.item_scrollbar = undefined
  self.payment_needed = -1
  self.has_shown_shipping_popup = false

  self.block_params = {
    message: null,
    overlayCSS: {
      'background-color': '#ffffff',
    },
  }

  self.open = function(e) {
    if (e != undefined) e.preventDefault()
    self.addClass('cart-panel--active')
    $('body').addClass('no-scroll')
  }

  self.close = function(e) {
    if (e != undefined) e.preventDefault()
    self.removeClass('cart-panel--active')
    $('body').removeClass('no-scroll')
  }

  self.checkout = function(e) {
    let has_local_pickup_item = self.find('input[name="has-local-pickup-item"]').val() == 'yes',
    shipped_items_total = parseFloat(self.find('input[name="shipped-items-total"]').val())
    if ((shipped_items_total > 0 && shipped_items_total < 115) || has_local_pickup_item) {
      if (!self.fancyboxOpened) {
        self.fancyboxOpened = true
        $.fancybox.open({
          src: has_local_pickup_item ? '.shipping-notification--special' : '.shipping-notification--standard',
          type: 'inline',
          touch: false,
          afterClose: function() {
            self.fancyboxOpened = false
          },
        });
      }
      e.preventDefault()
      return false;
    }
  }

  self.fragmentsRefreshed = function(response) {
    self.errors(response)
    self.fragmentsRequest = undefined
    if (response && response.fragments) {
      /* Replace fragments */
      $.each(response.fragments, function(key, value) {
        let skipFragment = false
        if (key == '.wc_payment_methods' && value.includes('wc_payment_methods--payment-needed') && $('.wc_payment_methods--payment-needed').length > 0) {
          skipFragment = true
        }
        if (!skipFragment) {
          $(key).replaceWith(value)
        }
      })

      /* Session storage */
      if ('sessionStorage' in window && window.sessionStorage !== null) {
        sessionStorage.setItem(window.wc_cart_fragments_params.fragment_name, JSON.stringify(response.fragments))
        sessionStorage.setItem(window.wc_cart_fragments_params.cart_hash_key, response.cart_hash)
        sessionStorage.setItem('wc_cart_created', (new Date()).getTime())
        localStorage.setItem(window.wc_cart_fragments_params.fragment_name, JSON.stringify(response.fragments))
        localStorage.setItem(window.wc_cart_fragments_params.cart_hash_key, response.cart_hash)
        localStorage.setItem('wc_cart_created', (new Date()).getTime())
      }

      /* Fragments refreshed */
      $(document.body).trigger('wc_fragments_refreshed')

      /* Checkout */
      if ($('body').hasClass('woocommerce-checkout')) {
        $('form.checkout').CheckoutForm().update_from_cart()
      }

      /* Reset add to cart form */
      $('.summary.entry-summary form.cart input[name="quantity"]').val(1).change()
      self.requestResponse = undefined
    }
  }

  self.refreshFragments = function(x) {
    if (typeof x === 'object' && x !== null) {
      self.fragmentsRefreshed(x)
    } else {
      self.fragmentsRequest = $.ajax({
        url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'get_refreshed_fragments'),
        type: 'POST',
        success: self.fragmentsRefreshed,
      })
    }
  }

  self.apply_gift_card = function(e) {
    if (e != undefined) e.preventDefault()
    self.block_ui()
    $.ajax({
      url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'apply_gift_card'),
      type: 'POST',
      data: {
        action: 'apply_gift_card',
        coupon_code: $('input[name="coupon_code"]').val(),
        is_checkout: $('body').hasClass('woocommerce-checkout'),
      },
      success: function(response) {
        if (response.success) {
          self.fragmentsRefreshed(response)
          $('input[name="coupon_code"]').val('')
          $('.coupon-wrapper').hide()
          $('.js-show-coupon').show()
          self.unblock_ui()
        } else {
          self.errors(response)
          self.unblock_ui()
        }
      },
      error: function() {
        self.unblock_ui()
        self.errors(response)
      }
    });
  }

  self.remove_gift_card = function(e) {
    let coupon = $(e.currentTarget).attr('data-giftcard')
    if (coupon) {
      self.block_ui()
      $.ajax({
        url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'remove_gift_card'),
        type: 'POST',
        data: {
          action: 'remove_gift_card',
          coupon_code: coupon,
          is_checkout: $('body').hasClass('woocommerce-checkout'),
        },
        success: function(response) {
          if (response.success) {
            self.fragmentsRefreshed(response)
            $('input[name="coupon_code"]').val('')
            $('.coupon-wrapper').hide()
            $('.js-show-coupon').show()
            self.unblock_ui()
          } else {
            self.errors(response)
            self.unblock_ui()
          }
        },
        error: function() {
          self.unblock_ui()
          self.errors(response)
        }
      });
    }
    return false
  }

  /* Le changement de livraison natif ne remplace que le Sommaire : la boîte Passer au paiement en reprend le total et la note de livraison */
  self.sync_skip = function() {
    const $totals = $('.cart_totals')
    if (!$totals.length) return
    const pending = $totals.find('tr.shipping.--no-shipping').length > 0
    const total = $totals.find('tr.order-total td').html()
    $('.mlmi-cart__skip').each(function() {
      $(this).find('.mlmi-cart__skip-note').toggleClass('mlmi-cart__skip-note--hidden', !pending)
      if (total) {
        $(this).find('.mlmi-cart__skip-total strong').html(total)
      }
    })
  }

  /* Chèque-cadeau du panier : wc_gc_sag_checkbox sans la case « Envoyer en cadeau », le plugin l'adresse à l'acheteur */
  self.add_gift_card = function(e) {
    e.preventDefault()
    const $button = $(e.currentTarget)
    const variation_id = $button.closest('.mlmi-cart__gift-card').find('input[name="gs_cart_gift_card"]:checked').val()
    if (!variation_id || $button.hasClass('loading')) return false
    const label = $button.html()
    $button.addClass('loading').html(gourmetsauvage_params.ADDING_TO_CART)
    self.block_ui()
    $.ajax({
      url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'add_to_cart'),
      type: 'POST',
      data: {
        product_id: $button.data('product_id'),
        variation_id: variation_id,
        quantity: 1,
        wc_gc_sag_checkbox: 'posted',
      },
      success: function(response) {
        self.unblock_ui()
        if (response.success) {
          self.fragmentsRefreshed(response)
          $button.html(gourmetsauvage_params.ADDED_TO_CART)
          setTimeout(function() {
            $button.removeClass('loading').html(label)
          }, 2000)
        } else {
          $button.removeClass('loading').html(label)
          self.errors(response)
        }
      },
      error: function() {
        self.unblock_ui()
        $button.removeClass('loading').html(label)
      }
    })
    return false
  }

  self.apply_coupon = function(e) {
    var regex = /^(?:\d{3,6}|[A-Za-z0-9]{4}(?:-[A-Za-z0-9]{4}){3})$/;
    if (regex.test($('input[name="coupon_code"]').val())) {
      self.apply_gift_card()
      return false;
    }
    if (e != undefined) e.preventDefault()
    self.block_ui()
    $.ajax({
      url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'apply_coupon'),
      type: 'POST',
      data: {
        action: 'apply_coupon',
        coupon_code: $('input[name="coupon_code"]').val(),
        is_checkout: $('body').hasClass('woocommerce-checkout'),
      },
      success: function(response) {
        if (response.success) {
          self.fragmentsRefreshed(response)
          $('input[name="coupon_code"]').val('')
          $('.coupon-wrapper').hide()
          $('.js-show-coupon').show()
          self.unblock_ui()
        } else {
          self.errors(response)
          self.unblock_ui()
        }
      },
      error: function() {
        self.unblock_ui()
        self.errors(response)
      }
    });
  }

  self.remove_coupon = function(e) {
    let coupon = $(e.currentTarget).attr('data-coupon')
    if (coupon) {
      self.block_ui()
      $.ajax({
        url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'remove_coupon'),
        type: 'POST',
        data: {
          action: 'remove_coupon',
          coupon_code: coupon,
          is_checkout: $('body').hasClass('woocommerce-checkout'),
        },
        success: function(response) {
          if (response.success) {
            self.fragmentsRefreshed(response)
            $('input[name="coupon_code"]').val('')
            $('.coupon-wrapper').hide()
            $('.js-show-coupon').show()
            self.unblock_ui()
          } else {
            self.errors(response)
            self.unblock_ui()
          }
        },
        error: function() {
          self.unblock_ui()
          self.errors(response)
        }
      });
    }
    return false
  }

  self.fix_coupon_display_mobile = function() {
    $('.cart-discount').each(function() {
      if (!$(this).find('> td > .mobile-coupon').length) {
        let $mobileCoupon = $('<div class="mobile-coupon"></div>')
        $mobileCoupon.append($(this).find('th').html())
        $(this).find('> td').prepend($mobileCoupon)
      }
    })
  }

  self.initialize_gift_card_toggle = function() {
    $(document).off('change', 'input[name="use_gift_cards_balance"]')
    $(document).on('change', 'input[name="use_gift_cards_balance"]', function() {
      self.block_ui()
      $.ajax({
        url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'toggle_balance_usage'),
        type: 'POST',
        data: {
          action: 'toggle_balance_usage',
          wc_gc_use_balance: $(this).prop('checked') ? 'on' : 'off',
        },
        success: function(response) {
          if (response.success) {
            self.fragmentsRefreshed(response)
            self.unblock_ui()
          } else {
            self.errors(response)
            self.unblock_ui()
          }
        },
        error: function() {
          self.unblock_ui()
          self.errors(response)
        }
      });
    })
  }

  self.calculate_shipping = function(e) {
    e.preventDefault()
    self.block_ui()
    $.ajax({
      type: 'POST',
      url: window.wc_cart_fragments_params.wc_ajax_url.replace('%%endpoint%%', 'calculate_shipping'),
      data: $(this).serialize(),
      success: function(response) {
        if (response.success) {
          self.unblock_ui()
          self.fragmentsRefreshed(response)
        } else {
          self.unblock_ui()
        }
      },
      error: function(error) {
        self.unblock_ui()
      }
    });
    return false
  }

  self.update = function(e) {
    if (e != undefined) {
      e.preventDefault()
    }
    if (self.fragmentsRequest != undefined) {
      self.fragmentsRequest.abort()
      self.fragmentsRequest = undefined
    }

    self.block_ui()

    let quantities = {}
    self.find('.mini_cart_item').each(function() {
      let quantity = parseInt($(this).find('input[name="quantity"]').val(), 10),
      item_key = $(this).find('.remove_from_cart_button').data('cart_item_key')
      if (isNaN(quantity)) {
        quantity = 0
      }
      if ($(this).hasClass('to-remove')) {
        quantity = 0
      } else if (quantity < 1) {
        $(this).addClass('to-remove')
        quantity = 0
      }
      quantities[item_key] = quantity
    })

    $('.to-remove').slideUp(200, function() {
      $(this).hide().remove()
    })

    $.post(woocommerce_params.ajax_url, {
      action: 'update_cart_quantities',
      quantities: quantities,
      is_checkout: $('body').hasClass('woocommerce-checkout'),
    }, function(response) {
      self.fragmentsRefreshed(response)
      self.unblock_ui()
    }, 'json')
  }

  self.quantity_changed = function() {
    self.update()
  }

  self.province_changed = function(province) {
    // if (province == undefined) {
    //   province = ''
    // }
    // if (!self.has_shown_shipping_popup) {
    //   if (province && province != 'QC') {
    //     let $popup = Popup.get('default')
    //     if ($popup) {
    //       $popup.display()
    //     }
    //     self.has_shown_shipping_popup = true
    //   }
    // }
  }

  self.initialize = function() {
    self.find('input.qty').each(function() {
      const quantityField = $(this).Quantity()
      quantityField.off('change', self.quantity_changed).on('change', self.quantity_changed)
    })

    /* Bouton de ré-ajout du produit gratuit (tooltip du rewards meter) */
    $('.rewards-meter__tooltip-add').each(function() {
      $(this).CartButton()
    })

    /* Maybe popup outside Quebec */
    $('select[name="calc_shipping_state"]').each(function() {
      self.province_changed($(this).val())
      $(this).on('change', function() {
        self.province_changed($(this).val())
      })
    })
    $('select[name="billing_state"]').each(function() {
      $(this).on('change', function() {
        if (!$('input[name="ship_to_different_address"]').prop('checked')) {
          self.province_changed($(this).val())
        }
      })
      if (!$('input[name="ship_to_different_address"]').prop('checked')) {
        self.province_changed($(this).val())
      }
    })
    $('select[name="shipping_state"]').each(function() {
      $(this).on('change', function() {
        if ($('input[name="ship_to_different_address"]').prop('checked')) {
          self.province_changed($(this).val())
        }
      })
      if ($('input[name="ship_to_different_address"]').prop('checked')) {
        self.province_changed($(this).val())
      }
    })

    /* Scrollbar in mini cart */
    if (!$('.woocommerce-mini-cart__wrapper').hasClass('scroller__container') && $('.woocommerce-mini-cart__wrapper').outerHeight(false) > 280) {
      $('.woocommerce-mini-cart__wrapper').css('height', '280px')
      self.item_scrollbar = new Scrollbar('.woocommerce-mini-cart__wrapper', {
        direction: 'vertical',
        desktop: true,
        mobile: true,
      })
    }

    /* Calculate shipping */
    $('form.woocommerce-shipping-calculator').off('submit').on('submit', self.calculate_shipping)

    /* Cart form */
    self.find('form.cart').each(function() {
      $(this).CartForm()
    })

    /* Initialize gift card toggle */
    self.initialize_gift_card_toggle()

    /* Fix coupon display in mobile */
    self.fix_coupon_display_mobile()

    /* Stripe form maybe */
    if ($('body').hasClass('woocommerce-checkout')) {
      if (self.payment_needed === -1) {
        self.payment_needed = $('.wc_payment_methods--no-payment-needed').length ? false : true
      } else if (self.payment_needed === false && $('.wc_payment_methods--no-payment-needed').length === 0) {
        self.payment_needed = true;
        $('.wc_payment_methods--payment-needed').hide()
        requestAnimationFrame(function() {
          self.block_ui()
          setTimeout(function() {
            location.reload()
          }, 250)
        })
      } else if (self.payment_needed === true && $('.wc_payment_methods--no-payment-needed').length === 1) {
        self.payment_needed = false;
      }
    }
  }

  self.block_ui = function() {
    if ($('body').hasClass('woocommerce-cart')) {
      $('form.woocommerce-cart-form').block(self.block_params)
      $('.mlmi-cart__shipping, .mlmi-cart__promo-code, .mlmi-cart__totals').block(self.block_params)
    } else if ($('body').hasClass('woocommerce-checkout')) {
      $('form.checkout').CheckoutForm().block_ui()
    }
  }

  self.unblock_ui = function() {
    if ($('body').hasClass('woocommerce-cart')) {
      $('form.woocommerce-cart-form').unblock()
      $('.mlmi-cart__shipping, .mlmi-cart__promo-code, .mlmi-cart__totals').unblock()
    } else if ($('body').hasClass('woocommerce-checkout')) {
      $('form.checkout').CheckoutForm().unblock_ui()
    }
  }

  self.errors_timeout = undefined
  self.errors = function(error) {
    if (!$('body').hasClass('woocommerce-account') && !$('body').hasClass('mon-compte') && !$('body').hasClass('my-account')) {
      requestAnimationFrame(function() {
        let messages = [],
        should_disappear = false
        if (error != undefined && error != '') {
          if ('success' in error) {
            let message = ''
            if ('added_message' in error) {
              message = error.added_message
              message += ' <a href="' + gourmetsauvage_params.cart_url + '">' + gourmetsauvage_params.my_cart + '</a>'
              should_disappear = true
            } else if ('message' in error) {
              message = error.message
            } else if ('data' in error && error.data.message != undefined) {
              message = error.data.message
            }
            if (message) {
              messages.push(message)
            }
          }
          if ('fragments' in error) {
            let notices = $('<div>').append(error.fragments['div.woocommerce-notices-wrapper'])
            notices.find('.woocommerce-message, .woocommerce-error').each(function() {
              messages.push($(this).html().replace(/[\t\n]/g, ''))
            })
          }
        }
        $('.woocommerce-notices-wrapper').find('.woocommerce-message, .woocommerce-error').each(function() {
          messages.push($(this).html().replace(/[\t\n]/g, ''))
        })
        $('.woocommerce-NoticeGroup').find('li').each(function() {
          messages.push($(this).html().replace(/[\t\n]/g, ''))
        })
        $('.wc-stripe-error').find('li').each(function() {
          messages.push($(this).html().replace(/[\t\n]/g, ''))
        })

        /* Display errors */
        clearTimeout(self.errors_timeout)
        if (messages.length) {
          let messages_output = $('<ul></ul>')
          messages.forEach(function(message) {
            messages_output.append($('<li></li>').html(message));
          })
          $('.mlmi-cart__messages').find('ul').remove()
          $('.mlmi-cart__messages').append(messages_output).attr('aria-hidden', 'false').attr('aria-expanded', 'true')
          $('.mlmi-cart__messages-expand').attr('aria-expanded', 'true').attr('aria-hidden', 'false')
          $('.mlmi-cart__messages-expand').off('click').on('click', function() {
            if ($('.mlmi-cart__messages').attr('aria-hidden') === 'true') {
              $('.mlmi-cart__messages-expand').attr('aria-expanded', 'true')
              $('.mlmi-cart__messages').attr('aria-hidden', 'false')
            } else {
              $('.mlmi-cart__messages-expand').attr('aria-expanded', 'false')
              $('.mlmi-cart__messages').attr('aria-hidden', 'true')
            }
          })
          self.errors_timeout = setTimeout(function() {
            $('.mlmi-cart__messages').attr('aria-hidden', 'true')
            $('.mlmi-cart__messages-expand').attr('aria-expanded', 'false')
          }, 5000)
        } else {
          $('.mlmi-cart__messages').find('ul').remove()
          $('.mlmi-cart__messages').attr('aria-hidden', 'true')
          $('.mlmi-cart__messages-expand').attr('aria-expanded', 'false').attr('aria-hidden', 'true')
        }
      })
    }
  }

  return function() {
    /* Open or close */
    $('.js-cart-button').on('click', self.open)
    $(document).on('click', '.js-cart-button', self.open)
    self.find('.cart-panel__close-btn').on('click', self.close)
    $(document).on('click', function(e) {
      let close = false
      if (!$(e.target).hasClass('js-cart-button') && $(e.target).parents('.cart-panel').length === 0 && $(e.target).parents('.js-cart-button').length === 0) {
        close = true
      }
      if ($(e.target).hasClass('fancybox-container') || $(e.target).parents('.fancybox-container').length) {
        close = false
      }
      if (close) {
        self.close()
      }
    })

    /* Apply coupon */
    $(document).on('click', 'button[name="apply_coupon"]', self.apply_coupon)
    $(document).off('click', '.js-cart-gift-card').on('click', '.js-cart-gift-card', self.add_gift_card)

    /* Checkout */
    $(document).on('click', '.js-checkout-button', self.checkout)

    /* Show calculator */
    $(document).on('click', '.js-show-calculator', function() {
      $(this).hide();
      $('.woocommerce-shipping-calculator').fadeIn(250)
    })

    /* Show coupon */
    $(document).on('click', '.js-show-coupon', function() {
      $(this).hide();
      $(this).closest('.js-accordion__panel').css('max-height', 'none');
      $('.coupon-wrapper').fadeIn(250)
      requestAnimationFrame(function() {
        $('input[name="coupon_code"]').focus()
      })
    })
    $(document).find('input[name="coupon_code"]').on('keydown', function(e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        e.preventDefault()
        self.apply_coupon()
      }
    })

    /* Remove coupon */
    $(document.body).off('click', 'a.mlmi-remove-coupon').on('click', 'a.mlmi-remove-coupon', self.remove_coupon)
    $(document.body).off('click', 'a.mlmi-remove-gift-card').on('click', 'a.mlmi-remove-gift-card', self.remove_gift_card)

    /* Initialize once */
    $(document.body).off('wc_fragments_loaded', self.initialize).on('wc_fragments_loaded', self.initialize)
    $(document.body).off('wc_fragments_refreshed', self.initialize).on('wc_fragments_refreshed', self.initialize)
    $(document.body).off('removed_from_cart', self.initialize).on('removed_from_cart', self.initialize)
    $(document.body).off('updated_checkout', self.initialize).on('updated_checkout', self.initialize)
    $(document.body).off('updated_checkout', self.unblock_ui).on('updated_checkout', self.unblock_ui)
    $(document.body).off('update_checkout', self.block_ui).on('update_checkout', self.block_ui)
    $(document.body).off('updated_shipping_method', self.unblock_ui).on('updated_shipping_method', self.unblock_ui)
    $(document.body).off('updated_cart_totals', self.sync_skip).on('updated_cart_totals', self.sync_skip)
    $(document.body).on('change', '#shipping_method input:not(.shipping-calculator-form input)', self.block_ui)
    setTimeout(self.initialize, 400) // after optimocha

    self.errors()
    return self
  }()
}

export default {
  init() {
    let cart = this
    if ($.mlmi.cart == undefined) {
      $('.mlmi-cart').each(function() {
        $.mlmi.cart = $(this).CartPanel()
      })
      if ($.mlmi.cart == undefined) {
        $.mlmi.cart = $('.menu__icon-item--cart').CartPanel()
      }
      $('form.checkout').each(function() {
        $('.woocommerce-checkout .mlmi-cart__col-left .accordion').CheckoutAccordion()
        $(this).CheckoutForm()
      })
    }
  },

  open() {
    if ($.mlmi.cart != undefined) {
      $.mlmi.cart.open()
    }
  },

  close() {
    if ($.mlmi.cart != undefined) {
      $.mlmi.cart.close()
    }
  },

  refresh(x) {
    if ($.mlmi.cart != undefined) {
      $.mlmi.cart.refreshFragments(x)
    }
  },
}
